import { useState } from "react";
import { Link } from "react-router-dom";
import { call } from "../firebase";
import { friendly, toast } from "../errors";
import { useSession } from "../session";
import { SITES, ROLE_LABEL, isGlobal, canUploadAny } from "../domain";

export default function Overview() {
  const { member } = useSession();
  const [checks, setChecks] = useState<{ name: string; ok: boolean; detail: string }[] | null>(null);
  const [busy, setBusy] = useState(false);
  const [mailing, setMailing] = useState(false);
  const [mailMsg, setMailMsg] = useState<{ ok: boolean; text: string } | null>(null);
  if (!member) return null;
  // L48: kết quả gửi email thử hiện ngay dưới nút (không chỉ là thông báo nổi dễ trôi mất)
  const testMail = async () => {
    setMailing(true); setMailMsg(null);
    try { const r = await call<object, { to: string; from: string }>("sendTestEmail")({}); setMailMsg({ ok: true, text: `Đã gửi email thử tới ${r.to} (từ ${r.from}). Kiểm tra hộp thư, cả mục Spam.` }); }
    catch (e) { setMailMsg({ ok: false, text: friendly(e) }); toast(friendly(e)); }
    setMailing(false);
  };
  const runCheck = async () => {
    setBusy(true); setChecks(null);
    try { setChecks((await call<object, { checks: { name: string; ok: boolean; detail: string }[] }>("systemCheck")({})).checks); }
    catch (e) { setChecks([{ name: "Gọi kiểm tra", ok: false, detail: friendly(e) }]); }
    setBusy(false);
  };
  // L45: Marketing xem ảnh/video mọi cơ sở, không tải lên
  const scope = isGlobal(member) || member.role === "marketing" ? "Tất cả cơ sở" : member.sites.map((s) => SITES[s]).join(", ") || "—";
  const upload = canUploadAny(member);
  return (
    <>
      <h1>Xin chào, {member.name}</h1>
      <p className="sub">{ROLE_LABEL[member.role]} · Phạm vi: {scope}</p>
      <div className="grid">
        <Link to="/documents" className="card" style={{ textDecoration: "none", color: "inherit" }}><b>Kho tài liệu</b><p className="sub">{member.role === "marketing" ? "Tìm và xem ảnh, video đã duyệt của mọi cơ sở." : upload ? "Tìm, xem và tải lên tài liệu." : "Tìm và xem tài liệu."}</p></Link>
        {upload && <Link to="/documents/upload" className="card" style={{ textDecoration: "none", color: "inherit" }}><b>Tải lên</b><p className="sub">Hub tự cấp mã và xếp thư mục.</p></Link>}
      </div>
      {member.role === "admin" && (
        <div className="card" style={{ marginTop: 24 }}>
          <div className="row" style={{ justifyContent: "space-between" }}><b>Kiểm tra kết nối kho &amp; bảo trì dữ liệu</b>
            <div className="row" style={{ gap: 8 }}>
              <button className="btn" disabled={mailing} onClick={testMail}>{mailing ? "Đang gửi email thử…" : "Gửi email thử"}</button>
              <button className="btn" disabled={busy} onClick={runCheck}>{busy ? "Đang kiểm tra…" : "Chạy kiểm tra"}</button></div></div>
          {mailMsg && <div className={mailMsg.ok ? "ok" : "err"} style={{ marginTop: 12 }}>{mailMsg.text}</div>}
          {checks && <table className="table" style={{ marginTop: 12 }}><tbody>
            {checks.map((c) => <tr key={c.name}><td>{c.ok ? "✅" : "❌"}</td><td>{c.name}</td><td style={{ fontSize: 13 }}>{c.detail}</td></tr>)}
          </tbody></table>}
        </div>
      )}
      <p className="sub" style={{ marginTop: 24 }}>Trang tổng quan đầy đủ (số liệu, cảnh báo, hoạt động gần đây) làm ở GĐ3 · RPT-01.</p>
    </>
  );
}
